import type {ClassValue} from "clsx"
import {clsx} from "clsx"
import {twMerge} from "tailwind-merge"

/** Merge Tailwind class lists, resolving conflicts (last wins). */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
